<script>
import AuthCard from '@components/auth-card'
import { authMethods } from '@state/helpers'

export default {
  page: {
    title: 'Member Login',
    meta: [{ name: 'description', content: 'Member login' }],
  },

  components: { AuthCard },

  props: {
    property: { type: Object, required: true },
    alert: { type: String, default: '' },
  },

  data: () => ({
    backgroundUrl: '/images/hero-main.jpg',
    form: {
      email: '',
      password: '',
    },
    authError: null,
    tryingToLogIn: false,
  }),

  methods: {
    ...authMethods,
    goToRegisterPage() {
      this.$router.push({
        name: 'member-register',
        params: {
          property: this.$route.params.property
        }
      })
    },
    submit() {
      this.tryingToLogIn = true
      this.authError = false

      return this.logIn({
        ...this.form,
        property: this.$route.params.permalink,
      })
        .then((token) => {
          this.tryingToLogIn = false
          // Redirect to the originally requested page, or to the home page
          this.$router.push(
            this.$route.query.redirectFrom || { name: 'member-profile' }
          )
        })
        .catch((error) => {
          let message = 'There was an error logging in to your account.'

          if (error.response) {
            message = error.response.data.message
          }

          this.tryingToLogIn = false
          this.authError = message
        })
    },
  },
}
</script>

<template>
  <AuthCard heading="Member Login" :alert="alert">
    <ValidationObserver v-slot="{ invalid, passes }" slim>
      <form @submit.prevent="passes(submit)">
        <BaseInput v-model="form.email" label="Email" rules="required|email" />

        <BaseInput
          v-model="form.password"
          type="password"
          label="Password"
          rules="required|min:8"
        />

        <p v-if="authError" class="text-sm text-red-500 italic px-3 mb-4">
          {{ authError }}
        </p>

        <div class="w-full flex flex-col px-3">
          <button
            type="submit"
            :class="[
              'btn btn-gold mb-6',
              { 'btn-disabled': invalid || tryingToLogIn },
            ]"
            :disabled="invalid || tryingToLogIn"
          >
            <i v-if="tryingToLogIn" class="fas fa-circle-notch fa-spin"></i>
            <span v-else>Log in</span>
          </button>

          <a class="cursor-pointer text-gold-500 hover:underline" @click.prevent="goToRegisterPage">Don't have an account? Register here</a>
        </div>
      </form>
    </ValidationObserver>
  </AuthCard>
</template>
